import { api } from "../base";
import type { IFixSessionList } from "@pulse-ui/codegen-v2/generated_ts/fix_session";

export type {
  IFixSession,
  IFixSessionList,
} from "@pulse-ui/codegen-v2/generated_ts/fix_session";

export interface GetFixSessionsParams {
  sender_comp_id?: string;
  target_comp_id?: string;
  limit?: number;
}

const fixSessionsEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getFixSessions: build.query<IFixSessionList, GetFixSessionsParams | void>({
      query: (params) => ({
        url: "/api/trading-ops/v1/fix-sessions",
        params: params || undefined,
      }),
      providesTags: ["FixSessions"],
    }),
  }),
});

export const { useGetFixSessionsQuery, useLazyGetFixSessionsQuery } = fixSessionsEndpoints;
